import { IMainMenu } from 'models/IMainMenu';
import { headerConnect as connect } from 'components/Shared/connect';
import styles from './styles.scss';
import cn from 'classnames';
import DesktopMenuItem from './desktopMenuItem';

interface MergedProps {
  menu: IMainMenu;
  openMenu: () => void;
  closeMenu: () => void;
}

const DesktopMenu = ({ menu }: MergedProps) => (
  <nav className={cn(styles.mainMenu, styles.desktopMenu)}>
    <ul className={styles.categories}>
      {menu.items.map(menuItem => (
        <DesktopMenuItem key={menuItem.id} {...menuItem} />
      ))}
    </ul>
  </nav>
);

export default connect<MergedProps>(state => ({
  menu: state.header.mainMenu
}))(DesktopMenu);
